<ul *ngIf="!isHidden" class="nav nav-tabs" [class.justify-content-end]="isRight">
  <li *ngIf="title.length && isRight" class="nav-item flex-fill" [class.tab-title-left]="">
    <span [class]="class_span">{{title}}</span>
    <span *ngIf="subTitle?.length" class="d-flex h7">{{subTitle}}</span>
  </li>
  <li *ngFor="let tab of items" class="nav-item align-self-end">
    <a class="nav-link" [class.active]="tab.key == active" (click)="onClick(tab)" role="button">
      <i *ngIf="tab.icon" [class]="tab.icon"></i>
      {{tab.value}}
    </a>
  </li>
</ul>
<ng-content></ng-content>